import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageComponent } from 'src/app/popups/message/message.component';
import { hasFutureOrTodayDate } from 'src/app/supporting/General';
import { LanguageManagementService } from 'src/service/language-management.service';
import { DeductionMethod, InteractionType, KeyValues3, KeyValueSet, LocalService, PlanPurchaseInvoiceDetailInitialization, PlanPurchaseInvoiceStatus, Status, TriggeredEvent } from 'src/service/local.service';
import { PlanPurchaseService } from 'src/service/plan-purchase.service';

@Component({
  selector: 'app-plan-purchase-detail',
  templateUrl: './plan-purchase-detail.component.html',
  styleUrl: './plan-purchase-detail.component.scss'
})
export class PlanPurchaseDetailComponent {
  PlanPurchaseInvoiceStatus = PlanPurchaseInvoiceStatus;
  InteractionType = InteractionType;
  lstSectionConfigKeys: string[] = ["common", "table", "plan_purchase"];
  ctryCode: string = ''; invoiceId: string = ''; userId: string; interactionType = 0; maxBodyHeight = 0;
  source: PlanPurchaseInvoiceDetailInitialization; grandTotal: number = 0; isPaymentDone: boolean = false;

  isOpenPlanPurchaseEdit = false; selectedKey?: string = undefined; elligibleDeductionTypeToSelect: KeyValueSet[] = [];
  businessDeductionTypes: DeductionMethod[] = [DeductionMethod.Online]; selectedDeductionType: string = DeductionMethod.Online.toString();

  isShowPayment: boolean = false; amountToRecharge: number = 0; businessId: string; isActivePlanAvailable = false;
  isShowRefundOtpPopup = false; additionalData: KeyValues3;
  isShowBuyPlanOtpPopup = false; additionalDataBuyPlan: KeyValues3;

  constructor(public localService: LocalService, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private planPurchaseService: PlanPurchaseService, private modalService: NgbModal, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.invoiceId = routeParams.invoiceId;
      this.ctryCode = routeParams.ctryCode;
      this.userId = routeParams.userId;
      this.onInitiate();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    if (this.interactionType == InteractionType.Business) {
      this.businessDeductionTypes.push(DeductionMethod.Wallet);
    }
    this.onLoad();
  }

  onLoad() {
    this.planPurchaseService.getPlanPurchaseInvoiceDetailInitialization(this.invoiceId).subscribe(result => {
      this.source = result;
      if (this.source && this.source.content) {
        if (this.source.content.items.length > 0) {
          const planDates = this.source.content.items.filter(x => x.v7).map(x => x.v7);
          this.isActivePlanAvailable = hasFutureOrTodayDate(planDates);
        }
        this.grandTotal = this.source.decuctedMethod == DeductionMethod.Waiver ? 0 : this.source.content.items.reduce((sum, item) => sum + parseFloat(item.v13), 0);
        this.businessId = this.source.businessId;
        if (this.interactionType == InteractionType.Bill_PnixSoft) {
          this.elligibleDeductionTypeToSelect = this.source.deductionMethods;
        } else {
          this.elligibleDeductionTypeToSelect = this.source.deductionMethods.filter(x => this.businessDeductionTypes.includes(parseInt(x.key)));
        }
        if (this.isPaymentDone && this.source.planPurchaseInvoiceStatus != PlanPurchaseInvoiceStatus.Generated) {
          this.isPaymentDone = false;
          this.onBuyPlan();
        }
      }
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 3: {
        this.selectedKey = key;
        this.isOpenPlanPurchaseEdit = true;
      } break;
      case 2: {
        const modalRef = this.modalService.open(MessageComponent);
        modalRef.componentInstance.IsConfirmationType = true;
        modalRef.componentInstance.message = this.localService.languageContent.common.delete_confirmation;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.planPurchaseService.deletePlanPurchaseInvoiceDetail(key).subscribe(result => {
              this.localService.showInformationByStatus(result.status);
              if (result.status == Status.Success) {
                this.onLoad();
              }
            });
          }
        });
      } break;
      case 4: {
        this.onSetStatus(PlanPurchaseInvoiceStatus.ToBuy);
      } break;
      case 5: {
        const selectedDeductionType: DeductionMethod = parseInt(this.selectedDeductionType);
        if (selectedDeductionType == DeductionMethod.Online) {
          this.amountToRecharge = this.grandTotal;
          this.isShowPayment = true;
        } else {
          this.onBuyPlan();
        }
      } break;
      case 6: {
        const lastUrl = this.localService.lastUrl;
        this.localService.lastUrl = '';
        if (lastUrl && lastUrl.length > 0) {
          this.router.navigate([lastUrl]);
        } else {
          this.router.navigate(['/plan-purchase', this.ctryCode, this.userId, this.interactionType, this.businessId, 2]);
        }
      } break;
      case 7: {
        this.onBuyPlanWithOtp();
      } break;
      case 8: {
        this.additionalData = {
          v1: this.grandTotal.toFixed(2),
          v2: 'Refund'
        } as KeyValues3;
        this.isShowRefundOtpPopup = true;
      } break;
      case 9: {
        this.onSetStatus(PlanPurchaseInvoiceStatus.Activated);
      } break;
      case 10: {
        this.onSetStatus(PlanPurchaseInvoiceStatus.Generated);
      } break;
    }
  }

  onBuyPlanWithOtp() {
    const modalRef = this.modalService.open(MessageComponent);
    modalRef.componentInstance.IsConfirmationType = true;
    modalRef.componentInstance.message = this.localService.languageContent.plan_purchase.paid_confirmation;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        const deductionType = this.elligibleDeductionTypeToSelect.find(x => x.key == this.selectedDeductionType);
        this.additionalData = {
          v1: this.grandTotal.toFixed(2),
          v2: deductionType.value
        } as KeyValues3;
        this.isShowBuyPlanOtpPopup = true;
      }
    });
  }

  onSetStatus(planPurchaseInvoiceStatus: PlanPurchaseInvoiceStatus) {
    this.planPurchaseService.setInvoiceStatus(this.invoiceId, planPurchaseInvoiceStatus, parseInt(this.selectedDeductionType), this.grandTotal).subscribe(result => {
      this.localService.showInformationByStatus(result.status, result.status != Status.Success);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }

  onBuyPlan(isConfirmed: boolean = false) {
    if (!isConfirmed) {
      isConfirmed = [DeductionMethod.Online, DeductionMethod.Wallet].includes(parseInt(this.selectedDeductionType));
    }
    if (isConfirmed) {
      this.planPurchaseService.buyPlanPurchaseInvoice(this.invoiceId, parseInt(this.selectedDeductionType)).subscribe(result => {
        this.localService.showInformationByStatus(result.status, result.status != Status.Success);
        if (result.status == Status.Success) {
          this.onLoad();
        }
      });
    } else {
      this.onBuyPlanWithOtp();
    }
  }

  onPlanPurchaseEditClosed(e) {
    this.isOpenPlanPurchaseEdit = false;
    if (!this.selectedKey) {
      this.onLoad();
    }
  }

  onRefundVerifiedOtp(e: any) {
    this.isShowRefundOtpPopup = false;
    this.onSetStatus(PlanPurchaseInvoiceStatus.Refunded);
  }

  onBuyPlanVerifiedOtp(e: any) {
    this.isShowBuyPlanOtpPopup = false;
    this.onSetStatus(PlanPurchaseInvoiceStatus.Generated);
  }

  onPaymentProccesed(e: any) {
    this.isPaymentDone = false;
    this.amountToRecharge = null;

    const status = e as Status;
    switch (status) {
      case Status.Success: {
        this.isPaymentDone = parseInt(this.selectedDeductionType) == DeductionMethod.Online;
        this.onLoad();
      } break;
    }
  }
}
